import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavComponent } from './nav/nav.component';
import { AuthComponent } from './views/auth/auth.component';
import { UnauthorizedComponent } from './views/error/unauthorized.component';
import { WhatsappConnectComponent } from './views/whatsapp-connect/whatsapp-connect.component';
import { CognitoGuard } from './cognito.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'unauthorized',
    pathMatch: 'full',
  },
  {
    path: '',
    component: NavComponent,
    canActivate: [CognitoGuard],
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'auth/info',
        component: AuthComponent,
      },
      /*
      {
        path: 'orders',
        loadChildren: () =>
          import('./views/orders/orders.module').then((m) => m.OrdersModule),
      },
      */
      {
        path: 'products',
        loadChildren: () =>
          import('./views/products/products.module').then(
            (m) => m.ProductsModule
          ),
      },
      {
        path: 'suppliers',
        loadChildren: () =>
          import('./views/suppliers/suppliers.module').then(
            (m) => m.SuppliersModule
          ),
      },
      {
        path: 'tags',
        loadChildren: () =>
          import('./views/tags/tags.module').then(
            (m) => m.TagsModule
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./views/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./views/chat/chat.module').then((m) => m.ChatModule),
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./views/documents/documents.module').then((m) => m.DocumentsModule),
      },
      {
        path: 'reportings',
        loadChildren: () =>
          import('./views/reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path: 'budget',
        loadChildren: () =>
          import('./views/budget/budget.module').then((m) => m.BudgetModule),
      },
      {
        path: 'tenant-config',
        loadChildren: () =>
          import('./views/tenant-config/tenant-config.module').then((m) => m.TenantConfigModule),
      },
      {
        path: 'pos-sync',
        loadChildren: () =>
          import('./views/pos-sync/pos-sync.module').then((m) => m.PosSyncModule),
      },
      {
        path: 'scheduled-tasks',
        loadChildren: () =>
          import('./views/scheduled-tasks/scheduled-tasks.module').then(
            (m) => m.ScheduledTasksModule
          ),
      }
    ]
  },
  {
    path: 'whatsapp-connect',
    component: WhatsappConnectComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
